const zeroPad = (num: number | string) => String(num).padStart(2, "0");

export default zeroPad;
